export enum TransportType {
  Email = 3,
  SMS = 4,
  App = 7,
}
